import { render, staticRenderFns } from "./classSelect.vue?vue&type=template&id=406f06e0&scoped=true&"
import script from "./classSelect.vue?vue&type=script&lang=js&"
export * from "./classSelect.vue?vue&type=script&lang=js&"
import style0 from "./classSelect.vue?vue&type=style&index=0&id=406f06e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f06e0",
  null
  
)

export default component.exports